import React, { useState, useEffect } from 'react';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { toast } from 'react-toastify';
import moment from 'jalali-moment';

// import JS files
import AdminOrderCard from '../../shares/AdminOrderCard';
import OrderCardLeftPartTemplate from '../../../shares/OrderCardLeftPartTemplate';
import TableIconModal from '../../../shares/TableIconModal';
import useFetch from '../../../../context/useFetch';
// import { defaultRingSize } from "../../../../constants/constants";
import SizeTextGrid from '../../../shares/SizeTextGrid';
import { useSetting } from '../../../../context/SettingContext';
import { fixNumbers } from '../../../../utils';
import MuiButton from '../../../shares/MuiButton';

const OrderDetails = (props) => {
  let windowWidth = window.screen.width;
  const { defaultRingSize } = useSetting();
  const [openModal, setOpenModal] = useState(false);
  const [checkBoxState, setCheckBoxState] = useState([]);

  const _chantgeBoxState = (item_id) => {
    let before = [...checkBoxState];
    if (before.includes(item_id)) {
      setCheckBoxState(before.filter((i) => i !== item_id));
      //  let id =  before.findIndex(item_id)
      //  before.splice (id,1)
      //  setCheckBoxState(before)
    } else {
      before.push(item_id);
      setCheckBoxState(before);
    }
  };

  const [currentOerdersDetail, setCurrentOerdersDetail] = useState({
    results: [],
    detail: {},
  });
  const [initialValues, setInitialValues] = useState({});
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(''));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };

  const getCreateOrderDetailsApi = useFetch({
    method: 'get',
    url: `Order_Service/${props.selectedRow?.id}/admin_get_order_item_detail_from_order`,
    trigger: false,
    setter: setCurrentOerdersDetail,
    argFunc: (res) => {
      let tmp = {};
      res.results.map((item, ind) => {
        tmp[item.id] = [];
        tmp[item.id].push(item.size_one_num);
        tmp[item.id].push(item.size_two_num);
        tmp[item.id].push(item.size_three_num);
        tmp[item.id].push(item.size_four_num);
        tmp[item.id].push(item.size_five_num);
        tmp[item.id].push(item.size_six_num);
      });

      setInitialValues(tmp);
    },
    errMessage: (mess) => {
      setOpenModal(false);
      props.adminGetCustomerReceviedOrderApi.reFetch();

      // toast.error('خطایی رخ داده است', {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
  });
  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const [postRevertData, setPostRevertData] = useState();
  const [childrenItemDate, setChildrenItemDate] = useState();
  const [selecteItemStatus, setSelectItemStatus] = useState();

  const deleteDetailsApi = useFetch({
    method: 'patch',
    url: `OrderItem_Service/${selectedItem}/update_order_item`,
    trigger: false,
    data: { is_active: !selecteItemStatus },
    argFunc: (res) => {
      // toast.success("ویرایش مورد  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getCreateOrderDetailsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error('خطایی رخ داده است', {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const revertItemApi = useFetch({
    method: 'post',
    url: `Order_Service/${props.selectedRow?.id}/admin_revert_order_item_selective_from_complete_to_onprogress`,
    trigger: false,
    data: postRevertData,

    argFunc: (res) => {
      // toast.success("ویرایش سفارش  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getCreateOrderDetailsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error('خطایی رخ داده است', {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const updateDetailsApi = useFetch({
    method: 'patch',
    url: `OrderItem_Service/${selectedItem}/update_order_item`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("ویرایش سفارش  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getCreateOrderDetailsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error('خطایی رخ داده است', {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    setPatchData({
      admin_size_one_num: parseInt(fixNumbers(initialValues[ringItemId][0])),
      admin_size_two_num: parseInt(fixNumbers(initialValues[ringItemId][1])),
      admin_size_three_num: parseInt(fixNumbers(initialValues[ringItemId][2])),
      admin_size_four_num: parseInt(fixNumbers(initialValues[ringItemId][3])),
      admin_size_five_num: parseInt(fixNumbers(initialValues[ringItemId][4])),
      admin_size_six_num: parseInt(fixNumbers(initialValues[ringItemId][5])),
      receive_at: moment(childrenItemDate).format('YYYY-MM-DD'),
    });
    updateDetailsApi.reFetch();
  };

  const delete_ring_item = (ringItemId, is_acitve) => {
    setSelectedItem(ringItemId);
    setSelectItemStatus(is_acitve);
    deleteDetailsApi.reFetch();
  };

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty('id')) {
          getCreateOrderDetailsApi.reFetch();
        }
  }, [openModal]);

  const admin_revent_order = () => {
    setPostRevertData({ ids: checkBoxState });
    revertItemApi.reFetch();
  };

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<RemoveRedEyeIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="flex justify-between mb-2">
            <div className="add-item-container">
              <span className="show-label">
                سند:{' '}
                <span className="show-value">
                  {' '}
                  {props.selectedRow?.unique_id}
                </span>
              </span>
            </div>
            <div className="md:block">
              <MuiButton
                onClick={admin_revent_order}
                variant="contained"
                // icon={<DoneIcon />}
                color="primary"
                text="بازگشت موارد انتخاب شده"
                disabled={revertItemApi.loading || checkBoxState.length == 0}
              />
            </div>
          </div>
          <SizeTextGrid haveExtraCol have5Col />
          <div className="overflow-scroll max-h-96">
            {currentOerdersDetail.results.map((item, index) => {
              return [
                <AdminOrderCard
                  update_ring_item={update_ring_item}
                  delete_ring_item={delete_ring_item}
                  item={item}
                  DontshowEditIconForAdmin
                  move_date_to_parent={move_date_to_parent}
                  dateDisabled
                  adminNeedDifference
                  showCheckBox
                  ChantgeBoxState={_chantgeBoxState}
                  CheckBoxState={checkBoxState}
                >
                  <OrderCardLeftPartTemplate
                    nums={nums}
                    update_nums={update_nums}
                    dynamicMap={true}
                    data_item={item}
                    ringId={item.id}
                    cantEdit
                    adminCantEdit
                    adminDidntNeedCustomerRequestNum
                    adminNeedColor
                  />
                </AdminOrderCard>,
              ];
            })}
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default OrderDetails;
